import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=6bc67990&scoped=true&"
import script from "./Domain.vue?vue&type=script&lang=js&"
export * from "./Domain.vue?vue&type=script&lang=js&"
import style0 from "./Domain.vue?vue&type=style&index=0&id=6bc67990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc67990",
  null
  
)

export default component.exports